import { useEffect, useState } from "react";
import { useGeneric } from "../useGeneric";
import { InvoiceMetadataType, InvoiceType } from "./InvoiceMetadataType";
import Loading from "../main/Loading";
import { InvoiceLine, KsefInvoice } from "./InvoiceType";
import SystemInvoice from "./SystemInvoice";

export default function KsefInvoiceMapper({
  invoice,
  invoiceItems,
  invoices,
  invoiceNumber,
  invoiceLoading,
  setInvoiceNumber,
  updates,
  setUpdates,
  doneInvoices,
  setDoneInvoices
}: {
  invoice: KsefInvoice;
  invoiceItems: InvoiceLine[];
  invoices: InvoiceMetadataType[];
  invoiceNumber: number;
  invoiceLoading: Boolean;
  setInvoiceNumber: Function;
  updates: number;
  setUpdates: Function;
  doneInvoices: any;
  setDoneInvoices: Function;
}) {
 
  const { customers, loading: loadingCustomer }: any = useGeneric({
    name: "get-client-by-nip",
    update: updates,
    query: {
      nip: 8951795339,
      //invoiceMetaData?.seller?.nip,
    },
  });

  const invoiceMetaData: InvoiceMetadataType | undefined =
    invoices?.at(invoiceNumber);

  const customer: any =
    !loadingCustomer && customers?.rows && customers?.rows?.at(0);

  return (
    <div>
      {invoiceLoading ? (
        <Loading variant={1} text={"Pobieranie faktury z KSeF"} />
      ) : (
        <></>
      )}
      <div className="invoice-mapping-main">
        <div>
          <div>Nr KSeF</div>
          <div>{invoiceMetaData?.ksefNumber}</div>
        </div>
        <div>
          <div>Kwota brutto</div>
          <div>{invoiceMetaData?.grossAmount}</div>
        </div>
        <div>
          <div>Kwota netto</div>
          <div>{invoiceMetaData?.netAmount}</div>
        </div>
        <div>
          <div>Kwota VAT</div>
          <div>{invoiceMetaData?.vatAmount}</div>
        </div>
        <div>
          <div>Sprzedający</div>
          <div>{invoiceMetaData?.seller?.name}</div>
        </div>
        <div>
          <div>NIP</div>
          <div>{invoiceMetaData?.seller?.nip}</div>
        </div>
        <div>
          <div>Adres w KSeF</div>
          <div>
            {invoice?.Podmiot1?.Adres?.AdresL1}
            <br />
            {invoice?.Podmiot1?.Adres?.AdresL2}
          </div>
        </div>
      </div>
      <div>
        <SystemInvoice
          invoice={invoice}
          invoiceLoading={invoiceLoading}
          items={invoiceItems}
          meta={invoiceMetaData}
          customer={customer}
          loadingCustomer={loadingCustomer}
          invoiceNumber={invoiceNumber}
          setInvoiceNumber={setInvoiceNumber}
          invoices={invoices}
          setUpdates={setUpdates}
          doneInvoices={doneInvoices}
          setDoneInvoices={setDoneInvoices}
        />
      </div>
    </div>
  );
}
